import React from 'react';
import { createRoot } from 'react-dom/client';
// Side-effect import: installs window error/unhandledrejection filters that
// suppress noise from browser wallet extensions (MetaMask, Phantom, etc.)
// before any app code can throw, so the CRA dev overlay never shows them.
import './setupGlobalErrorFilters';
// Side-effect import: installs the localStorage monkey-patch that powers
// "preview as manager" mode for the maintenance hub. MUST come before any
// React component (especially App / its routes) mounts, because the
// outer routing layer reads localStorage.getItem('managerUser') during
// its very first render. See previewSession.js for full details.
import './previewSession';
import App from './App';
import './DashboardMobile.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


const container = document.getElementById('root');
const root = createRoot(container);

// Then render your App
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
